<template>
    <div class="posfinder-screen">
        <Form
                @startSearch="executePosSearch"
                :loading="loading > 0"
                :defaultQuery="query"
                :initGeo="geo"
                :initial="initial"
                :defaultProduct="initialProduct"
        />
        <ResultList :initial="initial"/>
        <Map :initial="initial" :loading="minorLoading"/>
        <Spinner :loading="loading > 0"/>
    </div>
</template>

<script>
    import Form from "./Form";
    import ResultList from "./ResultList";
    import Spinner from "./partials/Spinner";
    import Map from "./Map";
    import {trackingPushLocationSearch} from "../tracking";

    export default {
        components: {Map, Spinner, ResultList, Form},
        props: {
            query: String,
            initialProduct: Number,
            geo: Boolean
        },
        data() {
            return {
                loading: 0,
                minorLoading: 0,
                results: [],
                initial: true
            }
        },
        mounted() {
            this.refreshProduct();
        },
        methods: {
            async refreshProduct() {
                this.loading++;
                await this.$store.dispatch('fetchPosProducts');
                this.loading--;
            },
            async executePosSearch({query, silent}) {
                if (silent) {
                    this.minorLoading++;
                } else {
                    this.loading++;
                }

                trackingPushLocationSearch(query);
                await this.$store.dispatch('executePosSearch', query);

                if (silent) {
                    this.minorLoading--;
                } else {
                    this.$store.commit('setFormOpenState', false);
                    this.$store.commit('setResultOpenState', false);
                    this.loading--;
                }
                this.initial = false;
            }
        }
    }
</script>
